<template>
    <div id="entouch1" class="entouch1">
        <div class="entouch1-box flex align-cen">
            <div class="entouch1-box-con">
                                <div class="swiper-container" >
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item,index) in list">
                        <img  :src="item.logo" alt=""  v-if="item.logo"
                        @click="getdetail(item.id,index)"
                        >
                         <div class="swiper-slide-mask" v-if="activeIndex == index">
                            <div class="mask-box">
                             <div class="mask-tit">
                                {{info.contentList[0].title}}
                            </div>
                            <div class="mask-tit1">
                                {{info.contentList[0].subtitle}}
                            </div>
                            <div class="mask-dec">
                                {{info.contentList[0].content}}
                            </div>
                            </div>
                            <div class="mask-de" @click="activeIndex = null">
                                <span class="el-icon-error"></span>
                            </div>
                        </div>
                    </div>
                </div>
                   <div class="swiper-button-next arrow" slot="button-next">
                     <span class="el-icon-caret-right"></span>
                   </div> 
                         <div class="swiper-button-prev arrow arrow1" slot="button-prev">
                   <span class="el-icon-caret-left"></span>
                         </div>
            </div>
            </div>
        </div>
    </div>
</template>
<script>
import {getListScreen,getScreenDetail} from "@/api/enterprise/index"   
import { Swiper, SwiperSlide,Navigation} from 'swiper';
import 'swiper/swiper-bundle.css'
Swiper.use([Navigation])
export default {
     components: {
    Swiper,
    SwiperSlide,
  },
    data () {
        return {
            activeIndex: null, // 存储当前激活项的索引
            show:[],
            info:{},
         isShow:false,
          swiper:{},
          list:[],
        }
    },
    mounted () { 
    },
    created() {
        this.getTouchList()
    },
    methods: {
        enter(id){
            this.isShow = true
        },
        leave(){ this.isShow = false},
        getdetail(id,index){
          getScreenDetail({id:id})
            .then(res =>{
            // 切换指定索引的显示状态
              this.info = res.data
              this.activeIndex = this.activeIndex == index ? null : index;
            })
        },
        // 获取列表
        getTouchList(){
            getListScreen({id:this.$route.query.id})
            .then(res =>{
                this.list = res.data
                if(this.list.length){
                                 this.$nextTick(() => {
                         this.swiper = new Swiper(".swiper-container", {
                slidesPerView: 3.5,
                spaceBetween: 10,
                navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
                },
             });
                     }) 
                }
            })
        },
    },
          beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  },
}
</script>
<style lang="scss" scoped>
.entouch1{
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: url("../../assets/images/peopleBg.png") no-repeat 0 0;
    background-size: 100% 100%;
    .entouch1-box{
        justify-content: center;
        height: inherit;
        width: 1200px;
        margin: 0 auto;
        position: relative;
        .entouch1-box-con{
            width: 100%;
            overflow: hidden;
            height:440px;
                     .swiper-container{
                    width: 100%;
                    height: 440px;
                    .swiper-slide{
                        background: rgba(0,0,0,.2);
                        width: 328px !important;
                        cursor: pointer;
                        position: relative;
                        img{
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                        .swiper-slide-mask{
                            width: 100%;
                            height: inherit;
                            background: rgba(20,128,231,.9);
                            position: absolute;
                            top: 0;
                            left: 0;
                            .mask-box{
                                padding: 30px 20px;
                            }
                            
                            .mask-de{
                                color: #fff;
                                position: absolute;
                                right: 10px;
                                top: 0px;
                                font-size: 24px;
                            }
                            .mask-tit{
                                font-size: 32px;
                                font-weight: bold;
                                color: #fff;
                            }
                             .mask-tit1{
                                font-size: 14px;
                                color: yellow;
                             }
                              .mask-dec{
                                font-size: 14px;
                                color: #fff;
                                margin-top: 10px;
                                height: 260px;
                                overflow-y: auto;
                             }
                             /*滚动条样式*/
        .mask-dec::-webkit-scrollbar {
            width: 4px;    
        }
        .mask-dec::-webkit-scrollbar-thumb {
            border-radius: 10px;
            box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
            background: rgba(0,0,0,0.2);
        }
        .mask-dec::-webkit-scrollbar-track {
            box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
            border-radius: 0;
            background: rgba(0,0,0,0.1);

        }
                            .mask-zz{
                                    height: 100%;
                                    width: 100%;
                                    cursor: pointer;
                                        text-align: center;
                                    i{
                                        color: #fff;
                                        font-size: 25px;
                                        line-height: 440px;
                                        padding-right: 20px;
                                    }
                                }

                        }
                    }
                    .swiper-button-prev{
                        margin-left: -80px;
                        left: auto;
                        width: 36px;
                        height: 36px;
                        background: rgba(255,255,255,.1);
                        border-radius: 50%;
                        cursor: pointer;
                    }
                    .swiper-button-prev::after{
                        content: none;
                    }
                    .swiper-button-next{
                        right: -80px;
                         width: 36px;
                        height: 36px;
                        background: rgba(255,255,255,.1);
                        border-radius: 50%;
                        cursor: pointer;
                    }
                    .swiper-button-next::after{
                         content: none;
                    }
                    .arrow{
                        font-size: 24px;
                        color: #072751;
                    }
                }
        }
    }
}
</style>